export enum HotelBookingType {
  Reservation = 0,
  Personal = 1,
  Group = 2
}
